import styled from "styled-components/macro";
import React from "react";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

const Inner = styled.div`
  padding: 16px;
  background: #f4f4f4;
  border-radius: 8px;
  text-align: center;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;
const TextTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;

const Text = styled.div``;

export const StudentAcceptedInviteMessage: React.FC<{ t: Function }> =
  React.memo(({ t }) => {
    return (
      <Root>
        <Inner>
          <TextTitle>
            {t("systemMessages.studentAcceptedInviteMessage.title")}
          </TextTitle>
          <Text>
            {t("systemMessages.studentAcceptedInviteMessage.infotext")}
          </Text>
        </Inner>
      </Root>
    );
  });
